import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs2/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime-corejs2/helpers/esm/inheritsLoose";
var _fadeStyles;
import classNames from 'classnames';
import React from 'react';
import Transition, { ENTERED, ENTERING } from 'react-transition-group/Transition';
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var fadeStyles = (_fadeStyles = {}, _fadeStyles[ENTERING] = 'in', _fadeStyles[ENTERED] = 'in', _fadeStyles);
var Fade = /*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Fade, _React$Component);
  function Fade() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = Fade.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      className = _this$props.className,
      children = _this$props.children,
      props = _objectWithoutPropertiesLoose(_this$props, ["className", "children"]);
    return /*#__PURE__*/React.createElement(Transition, props, function (status, innerProps) {
      return /*#__PURE__*/React.cloneElement(children, _extends({}, innerProps, {
        className: classNames('fade', className, children.props.className, fadeStyles[status])
      }));
    });
  };
  return Fade;
}(React.Component);
Fade.defaultProps = defaultProps;
export default Fade;